/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createMonthlyRevenueTrendFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type MonthlyRevenueTrend } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/revenue/trend
 */
export interface TrendRequestBuilder extends BaseRequestBuilder<TrendRequestBuilder> {
    /**
     * Breaks revenue over the period into one point per calendar month, newest month first. Months with no orders produce no point at all rather than a zero, so a chart that needs a continuous axis has to fill the gaps itself, and the series is shorter than the number of months you asked for whenever trade paused. The first and last months are partial whenever the range starts or ends mid-month — periodStart is the earliest order date seen in that month, not the first of the month. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<MonthlyRevenueTrend[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<TrendRequestBuilderGetQueryParameters> | undefined) : Promise<MonthlyRevenueTrend[] | undefined>;
    /**
     * Breaks revenue over the period into one point per calendar month, newest month first. Months with no orders produce no point at all rather than a zero, so a chart that needs a continuous axis has to fill the gaps itself, and the series is shorter than the number of months you asked for whenever trade paused. The first and last months are partial whenever the range starts or ends mid-month — periodStart is the earliest order date seen in that month, not the first of the month. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TrendRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Breaks revenue over the period into one point per calendar month, newest month first. Months with no orders produce no point at all rather than a zero, so a chart that needs a continuous axis has to fill the gaps itself, and the series is shorter than the number of months you asked for whenever trade paused. The first and last months are partial whenever the range starts or ends mid-month — periodStart is the earliest order date seen in that month, not the first of the month. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders returns an empty array.
 */
export interface TrendRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * Start of the period, inclusive. A start date part-way through a month yields a partialfirst point rather than a whole month.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const TrendRequestBuilderUriTemplate = "{+baseurl}/api/analytics/revenue/trend?endDate={endDate}&startDate={startDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TrendRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TrendRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createMonthlyRevenueTrendFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
